export default {"src":"https://search.prod.wiggot.com/_next/static/media/thunderbolt.e12c969b.svg","height":15,"width":17,"blurWidth":0,"blurHeight":0};